export default __webpack_public_path__ + "static/media/cafe-icon.4f715c9f.webp";